document.addEventListener('DOMContentLoaded', () => {
  const timers = document.querySelectorAll('.countdown-timer');
  if (!timers.length) {
    console.warn('No countdown timers found on page.');
    return;
  }

  timers.forEach(timer => {
    const endTimeStr = timer.dataset.endTime;
    if (!endTimeStr) {
      console.warn('Missing data-end-time attribute for:', timer);
      return;
    }

    const endTime = new Date(endTimeStr.replace(' ', 'T'));
    if (isNaN(endTime.getTime())) {
      console.warn('Invalid date format for:', timer, 'Value:', endTimeStr);
      return;
    }

    const hoursEl = timer.querySelector('.countdown-hours');
    const minutesEl = timer.querySelector('.countdown-minutes');
    const secondsEl = timer.querySelector('.countdown-seconds');

    if (!hoursEl || !minutesEl || !secondsEl) {
      console.warn('Missing one or more countdown elements inside:', timer);
      return;
    }

    function updateCountdown() {
      const now = new Date();
      const distance = endTime - now;

      if (distance <= 0) {
        hoursEl.textContent = '00';
        minutesEl.textContent = '00';
        secondsEl.textContent = '00';
        clearInterval(interval);
        return;
      }

      const hours = Math.floor(distance / (1000 * 60 * 60));
      const minutes = Math.floor((distance / (1000 * 60)) % 60);
      const seconds = Math.floor((distance / 1000) % 60);

      hoursEl.textContent = String(hours).padStart(2, '0');
      minutesEl.textContent = String(minutes).padStart(2, '0');
      secondsEl.textContent = String(seconds).padStart(2, '0');
    }

    // Try-catch ensures script won’t break even if updateCountdown fails unexpectedly
    try {
      updateCountdown();
      const interval = setInterval(updateCountdown, 1000);
    } catch (err) {
      console.error('Countdown error for timer:', timer, err);
    }
  });
});
